/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IRadiologyStudy } from 'app/shared/model/radiology-study.model';

export interface IStudy {
  id?: string;
  studyId?: string | null;
  studyDescription?: string | null;
  studyInstanceUid?: string | null;
  accessionNumber?: string | null;
  studyDateTime?: dayjs.Dayjs | null;
  referringPhysicianName?: string | null;
  additionalPatientHistory?: string | null;
  admittingDiagnosesDescription?: string | null;
  studyStatusId?: string | null;
  studyPriorityId?: string | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  statusCode?: string | null;
  patient?: IGlucoUser | null;
  rStudy?: IRadiologyStudy | null;
}

export const defaultValue: Readonly<IStudy> = {
  active: false,
};
